import request from './request'

export default class IpFiltersApi {
  async getIpFilters() {
    return await request(
      {
        environment: '/ipFiltering',
        type: 'query',
        name: 'getFilters',
        way: './graphql/ipFiltering/',
        has_catch: true}
    )
  }
  async getFiltersByClient(model) {
    return await request(
      {
        environment: '/ipFiltering',
        type: 'query',
        name: 'getFiltersByClient',
        variables: {model},
        way: './graphql/ipFiltering/',
        has_catch: true}
    )
  }
  async createFilter(model) {
    return await request({
      environment: '/ipFiltering',
      type: 'mutation',
      name: 'createFilter',
      variables: { model },
      way: './graphql/ipFiltering/'
    })
  }
  async updateFilter(model) {
    return await request({
      environment: '/ipFiltering',
      type: 'mutation',
      name: 'updateFilter',
      variables: { model },
      way: './graphql/ipFiltering/'
    })
  }
  async deleteFilter(id) {
    return await request({
      environment: '/ipFiltering',
      type: 'mutation',
      name: 'delete',
      variables: { id },
      way: './graphql/ipFiltering/'
    })
  }
  async refresheCache() {
    return await request({
      environment: '/ipFiltering',
      type: 'mutation',
      name: 'refresheCache',
      way: './graphql/ipFiltering/'
    })
  }

}
